import styled from "styled-components";

interface PointerDivProps {
  showPointer: boolean;
}

const PointerDiv = styled.div<PointerDivProps>`
  cursor: ${({ showPointer }) => (showPointer ? "pointer" : "default")};
`;

export default PointerDiv;
